<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Integração</p>
      <h1 class="text-2xl font-semibold leading-tight">Ekuro</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Cadastre clínicas e mantenha as mensagens de confirmação e lembrete organizadas.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Clínicas integradas</p>
        <strong class="text-lg">{{ listaDeClinicas.length || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Status</p>
        <strong class="text-lg">Ativo</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <mat-icon>hub</mat-icon>
        <span>Gerencie as clínicas integradas ao Ekuro.</span>
      </div>
      <div class="flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-base border border-border-color bg-white px-4 py-3 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color hover:text-primary-color"
          (click)="handleMostrarInformacoes()">
          <mat-icon>info</mat-icon>
          Informações
        </button>
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
          (click)="handleAbrirModalCadastroClinica()">
          <mat-icon>add</mat-icon>
          Adicionar clínica
        </button>
      </div>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Clínica</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">ID</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Ações</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr *ngFor="let clinica of listaDeClinicas" class="hover:bg-light-color/60 transition">
            <td class="px-4 py-3 text-dark-color">
              <div class="font-semibold">{{ clinica.nomeClinica }}</div>
              <span class="text-xs text-dark-color/70">Fila: {{ clinica.queueId }}</span>
            </td>
            <td class="px-4 py-3 text-dark-color">{{ clinica.clinicaId }}</td>
            <td class="px-4 py-3">
              <div class="flex justify-end gap-2">
                <button
                  type="button"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  title="Configurar"
                  (click)="handleAbrirModalConfiguracaoClinica(clinica)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  type="button"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-hover hover:text-primary-hover"
                  title="Excluir"
                  (click)="deletarClinica(clinica.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!listaDeClinicas?.length">
            <td colspan="3" class="px-4 py-6 text-center text-dark-color/70">
              Nenhuma clínica cadastrada.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<ng-container *ngIf="visibilidadeModalCadastroClinica">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalCadastroClinica()"></div>

    <div
      role="dialog" aria-modal="true"
      class="relative w-full max-w-4xl rounded-2xl border border-border-color bg-white shadow-xl flex max-h-[90vh] flex-col">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Cadastro</p>
          <h2 class="text-base font-semibold text-dark-color">Nova clínica</h2>
        </div>
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-xl p-2 hover:bg-light-color/60"
          (click)="closeModalCadastroClinica()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-5 py-4">
        <form [formGroup]="formularioInsercaoClinica" class="space-y-5" (ngSubmit)="handleEnviarCadastroClinica()">
          <div class="grid gap-4 md:grid-cols-2">
            <label class="block text-sm text-dark-color">
              Nome da clínica
              <input
                type="text"
                formControlName="nomeClinica"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              ID da clínica
              <input
                type="text"
                formControlName="clinicaId"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              App Access Token
              <input
                type="text"
                formControlName="appAccessToken"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              Host
              <input
                type="text"
                formControlName="host"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              ApiKey
              <input
                type="text"
                formControlName="apiKey"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              ID Fila
              <input
                type="text"
                formControlName="queueId"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              Horário de envio
              <input
                type="time"
                formControlName="horario"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              D+ (para confirmação)
              <input
                type="number"
                formControlName="somaDia"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>
          </div>

          <label class="block text-sm text-dark-color">
            Mensagem de confirmação de consulta
            <textarea
              rows="4"
              formControlName="mensagemConfirmacaoConsulta"
              class="mt-1 block w-full max-w-full box-border resize-y rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"></textarea>
          </label>

          <label class="block text-sm text-dark-color">
            Mensagem de lembrete de consulta
            <textarea
              rows="4"
              formControlName="mensagemLembreteConsulta"
              class="mt-1 block w-full max-w-full box-border resize-y rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"></textarea>
          </label>

          <div class="flex flex-col gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color"
              (click)="closeModalCadastroClinica()">
              Cancelar
            </button>
            <button
              type="submit"
              class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-50"
              [disabled]="!formularioInsercaoClinica.valid">
              Cadastrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="mostrarInformacoes">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="handleMostrarInformacoes()"></div>

    <div
      role="dialog" aria-modal="true"
      class="relative w-full max-w-2xl rounded-2xl border border-border-color bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <h2 class="text-base font-semibold text-dark-color">Informações importantes</h2>
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-xl p-2 hover:bg-light-color/60"
          (click)="handleMostrarInformacoes()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="space-y-4 px-5 py-4 text-sm text-dark-color">
        <p class="font-semibold">Instruções de configuração:</p>
        <p>
          Para utilizar alguma variável na mensagem, use entre chaves.<br>
          Ex: <strong>{{ '{' }}nome_paciente{{ '}' }}</strong>
        </p>
        <div class="border-t border-border-color pt-4">
          <p class="mb-2 font-semibold">Variáveis disponíveis:</p>
          <ul class="space-y-2">
            <li>nome_paciente - Nome do paciente.</li>
            <li>data - Data do agendamento da consulta.</li>
            <li>horario - Horário do agendamento da consulta.</li>
            <li>doutor - Doutor responsável pela consulta no agendamento.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="clinicaSelecionada && visibilidadeModalConfiguracaoClinica">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalConfiguracaoClinica()"></div>

    <div
      role="dialog" aria-modal="true"
      class="relative w-full max-w-4xl rounded-2xl border border-border-color bg-white shadow-xl flex max-h-[90vh] flex-col">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Configuração</p>
          <h2 class="text-base font-semibold text-dark-color">{{ clinicaSelecionada.nomeClinica }}</h2>
        </div>
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-xl p-2 hover:bg-light-color/60"
          (click)="closeModalConfiguracaoClinica()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-5 py-4">
        <form [formGroup]="formularioEdicaoClinica" class="space-y-5" (ngSubmit)="handleEnviarAtualizacaoClinica()">
          <div class="grid gap-4 md:grid-cols-2">
            <label class="block text-sm text-dark-color">
              Nome da clínica
              <input
                type="text"
                formControlName="nomeClinica"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              ID da clínica
              <input
                type="text"
                formControlName="clinicaId"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              App Access Token
              <input
                type="text"
                formControlName="appAccessToken"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              Host
              <input
                type="text"
                formControlName="host"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              ApiKey
              <input
                type="text"
                formControlName="apiKey"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              ID Fila
              <input
                type="text"
                formControlName="queueId"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              Horário de envio
              <input
                type="time"
                formControlName="horario"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>

            <label class="block text-sm text-dark-color">
              D+ (para confirmação)
              <input
                type="number"
                formControlName="somaDia"
                class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>
          </div>

          <label class="block text-sm text-dark-color">
            Mensagem de confirmação de consulta
            <textarea
              rows="4"
              formControlName="mensagemConfirmacaoConsulta"
              class="mt-1 block w-full max-w-full box-border resize-y rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"></textarea>
          </label>

          <label class="block text-sm text-dark-color">
            Mensagem de lembrete de consulta
            <textarea
              rows="4"
              formControlName="mensagemLembreteConsulta"
              class="mt-1 block w-full max-w-full box-border resize-y rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"></textarea>
          </label>

          <div class="flex flex-col gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color"
              (click)="closeModalConfiguracaoClinica()">
              Cancelar
            </button>
            <button
              type="submit"
              class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
              Atualizar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>
